import { getISOWeek } from "date-fns";

export function buildDateMap(startDate: string, endDate: string) {
  const map = new Map<string, Date>();
  const start = new Date(startDate);
  const end = new Date(endDate);

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const week = getISOWeek(d);
    const weekday = d
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();

    const safeDate = new Date(d);
    safeDate.setHours(0, 0, 0, 0);

    map.set(`${week}-${weekday}`, safeDate);
  }

  return map;
}
